/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_proximity.js                                                                         */
/**********************************************************************************************************************/
/* Controller.Reachability */

HafasWebapp.prototype.Controller.Reachability = {
  currentForm: null,    // um außerhalb von postForm eine Referenz auf das Formular zu haben; wird in index gesetzt
  index: function (data) {
    Hafas.ps.pub('/options/gui/close/groups', [{}]);
    try {
      if (Hafas.Config.Switches.useFavorites) {
        this.Controller.Favorites.instance.checkDataConsistency();
        // getData(1): alle locations, die nicht vom Typ 1 (Station) sind,
        // erhalten den Wert display = false. Auf diesen wird im Template common.tabs.html gepr�ft
        var favorites = this.Controller.Favorites.instance.getData();
      }

      if (Hafas.Modules.History)
        Hafas.Modules.History.addData("Reachability", "index", {});

      var model = {};


      var useFavorites = Hafas.Config.Switches.useFavorites;
      if (Hafas.Config.Reachability.useQueryOptions === true) {
        model.customerOptions = this.Controller.Reachability.options.get();
        model.optionsChanged = this.Controller.Reachability.options.haveOptionsChanged();
      }
      model.customerFavorites = useFavorites ? this.Controller.Favorites.instance.getData() : null;
      model.useOptions = Hafas.Config.Reachability.useQueryOptions;

      model.useDateTimePicker = Hafas.Config.Reachability.useDateTimePicker;
      var tmpLocation = this.Controller.Reachability.instance.getLocation();
      if (tmpLocation) {
        model.stationInput = tmpLocation.name;
      }

      model.travelPeriods = [
        {
          value: 30,
          label: Hafas.Modules.i18n.get('Reachability.t_N_PeriodValue', {value: 30})
        },
        {
          value: 60,
          label: Hafas.Modules.i18n.get('Reachability.t_N_PeriodValue', {value: 60})
        },
        {
          value: 120,
          label: Hafas.Modules.i18n.get('Reachability.t_N_PeriodValue', {value: 120})
        }
      ];
      for (var p = 0; p < model.travelPeriods.length; p++) {
        var tmpPeriod = model.travelPeriods[p];
        if (tmpPeriod.value == this.Controller.Reachability.instance.getPeriod()) {
          tmpPeriod.selected = true;
        }
      }

      model.travelTime = this.Controller.Reachability.instance.getTravelTime();

      var me = this;
      Hafas.Core.newType("hafasLoader", {
        file: 'reachability.index.html',
        tplId: 'Reachability_TplIndex',
        callback: function (templateId) {
          var master = templateId;

          Hafas.Modules.Render.render({
            target: me.formContainer,
            template: master,
            model: model
          }, function () {

            var formContainer = Hafas("#" + me.formContainer);
            me.Controller.Reachability.currentForm = Hafas('#HFS_FormReachabilitySearch', false, formContainer);

            // Lade eventuell ge�nderte Optionen in die Formular-GUI
            Hafas.ps.pub('/options/setChangedOptionsInputForm');

            Hafas.ps.pub('/options/init', [{context: "Reachability"}]);

            me.Controller.Reachability.inpStation = Hafas.Core.newType('hafasSuggest', {
              loc: "ReachabilityLocation",
              type: "S",
              onSelect: function (loc) {
                Hafas.bind(me.Controller.Reachability.validateSelection, me)();
                // Setze Marker für gesuchte Location
                Hafas.bind(me.Controller.Reachability.setLocationMarker, me)(loc);
              }
            });

            var _timeObj = Hafas.Core.newType("hafasTime", {
              date: me.Controller.Reachability.instance.getRequestDate(),
              time: me.Controller.Reachability.instance.getRequestTime()
            });

            // setting tdp-configuration
            if (Hafas.Config.Reachability.useDateTimePicker) {
              var dateTimePickerConfig = {
                holder: "HFS_ReachabilityDateTimePickerHolder",
                id: "ReachabilityDTP",
                config: {
                  useDepArrSwitch: false
                },
                current: {
                  date: me.Controller.Reachability.instance.getRequestDate(),
                  time: me.Controller.Reachability.instance.getRequestTime(),
                  isNowMode: me.Controller.Reachability.instance.getTimeNow()
                }
              };
              me.Controller.Reachability.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);
              me.Controller.Reachability.instance.setTimeNow(true);
            } else {
              me.Controller.Reachability.instance.setTimeNow(false);
            }

            me.Controller.Reachability.travelPeriod = Hafas.Core.newType('HafasSelectBox', {
              holder: 'HFS_ReachabilityTravelPeriod_Holder', callback: function (data) {
                Hafas.ps.pub('/reachability/changePeriod', [data.value]);
              }
            }).initiate();




            Hafas.ps.pub('/GUI/form/show', [{}]);

            var reachLoc = me.Controller.Reachability.instance.getLocation();
            if (reachLoc != null) {
              Hafas('#ReachabilityLocation', false).value = reachLoc.name;
            }

            me.Controller.Reachability.travelTimeSlider = Hafas.Core.newType("HafasRangeSlider", {
              holder: 'HFS_ReachabilityJnySlider',
              valueDescriptionPluralizeI18nEntry: 'common.times.t_N_Minutes',
              callback: function (data) {
                if (data && typeof data.value != 'undefined') {
                  if(data.value != me.Controller.Reachability.instance.getTravelTime()) {
                    me.Controller.Reachability.instance.setTravelTime(data.value);
                    if(me.layoutClass != 'small') {
                      Hafas.ps.pub("/reachability/update",[{form: Hafas('#HFS_FormReachabilitySearch',false)}]);
                    }
                  }
                }
              }
            }).initiate();


            // Favoriten als SegmentedControl
            if (Hafas.Config.UI.showFavoriteBox === true) {
              Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_CustomerFavoritesWrap'}).initiate();
            }

            Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
            Hafas.ps.pub('/favorites/update');
            Hafas.ps.pub('/app/events/resize');
            Hafas.ps.pub('/tracking/screen/proximity-planner-main');

            Hafas.Util.gui.focusTabOrMenuButton();
          });

          //   }
          // });
        }
      });
    } catch (e) {
      Hafas.logger.error(
        Hafas.logger.ERROR_TYPES.JS,
        "reachability.index",
        "",
        e
      );
    }
  },
  selectDateTimeFromPicker: function (hciDate, hciTime, enquiry, nowMode) {
    this.Controller.Reachability.instance.setRequestTime(hciTime);
    this.Controller.Reachability.instance.setRequestDate(hciDate);
    this.Controller.Reachability.instance.setTimeNow(nowMode);
  },
  setDate: function (hcidate) {
    this.Controller.Reachability.instance.setRequestDate(hcidate);
    this.Controller.Reachability.dateTimePicker.setDate(hcidate);
    this.Controller.Reachability.dateTimePicker.updateDisplay();
  },
  setTime: function (hcitime) {
    this.Controller.Reachability.instance.setRequestTime(hcitime);
    this.Controller.Reachability.dateTimePicker.setTime(hcitime);
    this.Controller.Reachability.dateTimePicker.updateDisplay();
  },
  setTimeNow: function (nowMode) {
    this.Controller.Reachability.instance.setTimeNow(nowMode);
    this.Controller.Reachability.dateTimePicker.setTimeNow(nowMode);
    this.Controller.Reachability.dateTimePicker.updateDisplay();
  },
  validateSelection: function () {
    // form validieren
    this.Controller.Reachability.validate(['ReachabilityLocation'], Hafas.bind(function () {
      Hafas.Core.newType("hafasValidation", {
        form: this.Controller.Reachability.currentForm
      });
    }, this));
  },
  postForm: function (data) {
    try {
      if (typeof data.ev != 'undefined')
        data.ev.preventDefault();
      var me = this;

      this.Controller.Reachability.validate(['ReachabilityLocation'], Hafas.bind(function () {
        var form = Hafas.Core.newType("hafasValidation", {
          form: data.form
        });
        Hafas.ps.pub('/app/events/resize');
        if (form.valid) {
          Hafas.bind(this.Controller.Reachability.startSearch, this)(data);

          // Track
          Hafas.ps.pub('/tracking/event/proximity-request', ['[' + me.appContext + '] FOR: ' + data.form.elements.ReachabilityLocation.value]);
        }
        // If input wasn't previously validated, validation will cause the suggest to open. Blur to close it.
        this.Controller.Reachability.inpStation.inp.blur();
      }, this));
    } catch (e) {
      Hafas.logger.error(
        Hafas.logger.ERROR_TYPES.JS,
        "reachability.postForm",
        "",
        e
      );
    }
  },
  validate: function (items, callback) {
    var reachabilityController = this.main.Controller.Reachability;
    var resolvedCount = 0;
    var itemLength = items.length;

    // Increments the counter, firing the callback when all items are resolved
    function resolveMe() {
      resolvedCount++;
      if (resolvedCount === itemLength) {
        callback();
      }
    }

    for (var i = 0; i < itemLength; i++) {
      var location = reachabilityController.instance.getLocation();
      var input = reachabilityController.inpStation;
      var inputText = input.getInputText();

      // location and inputtext aren't synchronized.
      if(!location && inputText) {
        location = {name:inputText};
      }

      // Location is valid -> resolve
      if (Hafas.Util.location.isValid(location) && Hafas.Util.getLocationAttribute(location,'name') === inputText) {
        resolveMe();
      } else {
        // Something is missing in location -> validate -> LocMatch -> resolve
        if(Object.keys(location).length > 0) {
          input.validateLocation(true, resolveMe);
        } else {
          // Empty Location -> resolve -> show error (see validateQueryLocations)
          resolveMe();
        }
      }
    }
  },
  searchFromMapPosition: function (data) {
    data = Hafas.Modules.Render.objectKeeper.get(data);
    var toolboxButton = Hafas('[data-proximity-toolbox="button"]', false);
    var toolboxSpinner = Hafas('[data-proximity-toolbox="spinner"]', false);
    if (toolboxSpinner) {
      Hafas.Util.gui.setVisibility(toolboxSpinner, true);
    }
    if (toolboxButton) {
      Hafas.Util.gui.setVisibility(toolboxButton, false);
    }

    // Hide edit smartLocation view if opened and show form
    Hafas.ps.pub('/favorites/smartLocations/closeView');
    Hafas.ps.pub('/GUI/form/show', [{}]);

    // Nur für Desktop & Tablet relevant
    if (!Hafas('#HFS_WebApp').classList.contains('layout-small')) {
      // Mantis-Task: #0069343: Flyoutfunktion: Erreichbarkeitssuche sollte entsprechenden Tab öffnen
      Hafas.ps.pub('/app/switchContext', [{
        context: 'Reachability',
        method: 'index',
        backJumpTarget: data.backJumpTarget || null
      }]);
    }
    this.Controller.Reachability.instance.setLocation(data);

    // Setze Marker für gesuchte Location
    Hafas.bind(this.Controller.Reachability.setLocationMarker, this)(data);

    this.Controller.Reachability.instance.startSearch();
  },
  setLocation: function (loc) {
    this.Controller.Reachability.instance.setLocation(loc);
  },
  triggerLoadingImage: function(data){
    if (data.form.elements.submitReachabilityForm) {
      Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitReachabilityForm);
    }
  },
  startSearch: function (data) {
    if (this.Controller.Reachability.instance.originLoc != null) {
      this.Controller.Reachability.instance.startSearch();
      this.Controller.Reachability.triggerLoadingImage.bind(this)(data);
      this.Controller.Reachability.showInfiniteLoader();
    }
  },
  showInfiniteLoader: function(){
    var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite", {id: "HFS_Reachability_OverviewLoader"},{suppressAnnouncements: true});
    var mapNotifications = Hafas('#HFS_PageMapNotifications');
    var loader = document.createElement("div");
    loader.innerHTML = loaderHtml;
    mapNotifications.appendChild(loader);
  },
  removeInfiniteLoader: function(){
    var loaderElement = Hafas('#HFS_Reachability_OverviewLoader');
    if(loaderElement) {
      var parentLoader = loaderElement.parentNode.parentNode;
      Hafas('#HFS_PageMapNotifications').removeChild(parentLoader);
    }
  },
  hideResult: function () {
    this.Controller.Reachability.instance.hide();
  },
  /**
   * Setzt den Marker auf die Karte und zentriert diesen
   * @param loc Location / Objekt mit lid Eigenschaft
   */
  setLocationMarker: function (loc) {
    // Wenn loc ein String ist, versuche die Daten/lid aus dem ObjectKeeper zu bekommen
    if (typeof loc === "string") {
      loc = Hafas.Modules.Render.objectKeeper.get(loc);
    }
    var mapController = this.Controller.Map;
    var mapInstance = mapController.instance;

    // Vorherigen Stationmarker entfernen
    Hafas.bind(this.Controller.Reachability.removeStationMarker, this)();

    // Vorheriges Ergebnis entfernen
    Hafas.bind(this.Controller.Reachability.hideResult, this)();

    if (loc != null && loc.lid != undefined && Hafas.Config.Switches.useMap == true) {
      var tmpX = loc.crd.x;
      var tmpY = loc.crd.y;
      if (tmpX && tmpY) {
        var crd = Hafas.Core.newType("hafasCCoord", {
          lon: tmpX,
          lat: tmpY
        });
        var markerTmpl = 'SELECTION';
        var markerCfg = Hafas.Config.Maps.Marker;
        var params = {
          type: 'location',
          coord: crd,
          imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_' + markerTmpl),
          imagewidth: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_WIDTH'],
          imageheight: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_HEIGHT'],
          hotspot: {
            x: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_X'],
            y: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_Y']
          },
          text: loc.name,
          priority: 10000,
          draggable: false,
          onDrag: function (coord, marker, map) {

          }
        };
        this.stationMarker = mapInstance.createContent(params);
        mapInstance.showContent(this.stationMarker);
        mapInstance.centerToContent(this.stationMarker, {zoom: 14});
        mapInstance.currentPositionMarker = this.stationMarker;
      }
    }
  },
  removeStationMarker: function () {
    var mapController = this.Controller.Map;
    var mapInstance = mapController.instance;
    if (this.stationMarker != null) {
      mapInstance.hideContent(this.stationMarker);
      mapInstance.removeContent(this.stationMarker);
      this.stationMarker = null;
    }
  },
  /**
   * Set the travel period.
   * @param {(string|number)} period - The length of the period in minutes. Must be one of the options in the select.
   */
  changePeriod: function (period) {
    var intValue = parseInt(period);
    this.Controller.Reachability.instance.setPeriod(intValue);
    this.Controller.Reachability.travelPeriod.setActiveValue(period);
    // Track
    var _me = this;
    Hafas.ps.pub('/tracking/event/proximity-settings-period', ['[' + _me.appContext + '] PERIOD: ' + intValue])
  },
  /**
   * Set the maximum travel time.
   * @param {(string|number)} travelTime - The maximum travel time in minutes. Must be a multiple of ten to be displayed correctly.
   */
  changeTravelTime: function (travelTime) {
    this.Controller.Reachability.instance.setTravelTime(travelTime);
    this.Controller.Reachability.travelTimeSlider.setValue(travelTime);
    this.Controller.Reachability.travelTimeSlider.update();
  },
  changeMode: function (data) {
    var selectBox = data.source;
    var selectedValue = data.source.options[data.source.selectedIndex].value;
    if (selectedValue == 'out') {
      this.Controller.Reachability.instance.setFrwd(true);
    } else {
      this.Controller.Reachability.instance.setFrwd(false);
    }
  },
  changeDay: function (data) {
    var selectBox = data.source;
    var selectedValue = data.source.options[data.source.selectedIndex].value;
    var hciDate = this.Controller.Reachability.instance.getNextDay(selectedValue);
    this.Controller.Reachability.instance.setRequestDate(hciDate);
  },
  showResult: function (data) {
    // remove loadingImage
    this.Controller.Reachability.removeInfiniteLoader();

    // Announce that loading ended
    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));
    var me = this;
    if (me.trigger) {
      if (me.triggerLoadingImage) {
        try {
          me.trigger.removeChild(me.triggerLoadingImage);
          delete me.triggerLoadingImage;
        } catch (e) {
          // do nothing
        }
      }
      me.trigger.removeAttribute('disabled');
    }
    if (this.layoutClass == 'small' && window.getComputedStyle(Hafas('#' + this.mapContainer, false)).visibility != 'visible') {
      Hafas.ps.pub('/GUI/map/show', [{trigger: this, ev: {}, template: 'Common_MapPageHeaderConnection'}]);
    }
    Hafas.bind(this.Controller.Reachability.addToSearchHistory, this)();
  },
  addToSearchHistory: function () {
    var reachLoc = this.Controller.Reachability.instance.getLocation();
    this.Controller.Favorites.instance.addLocation(reachLoc, 'History');
    Hafas.ps.pub('/favorites/update');
  },
  showLocationSelectionPopover: function(data,triggerElem){
    var _me = this;
    var model = {
      loc: Hafas.Modules.Render.objectKeeper.get(data.loc),
      id: data.id,
      favEntry: data.favEntry
    };

    triggerElem.parentNode.addClassName('lyr_selectedFav');

    if(_me.Controller.Reachability.locationSelectPopover) {
      Hafas.bind(_me.Controller.Reachability.hideLocationSelectionPopover, _me)();
    }

    model.popoverCloseEvent = '/reachability/favorites/closeLocationPopover';
    _me.Controller.Reachability.locationSelectPopover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      anchorElement: triggerElem.parentNode,
      anchoredOverlay: 'DESKTOP',
      triggerElement: triggerElem,
      outputHTML: Hafas.Modules.Render.renderTemplate("Reachability_AtomTplLocationSelectPopover", model),
      cssClass: 'lyr_locationSelectPopover',
      onClose: function () {
        var anchor = this.Controller.Reachability.locationSelectPopover.getAnchorElement();
        if (anchor) {
          anchor.removeClassName('lyr_selectedFav');
        }
        this.Controller.Reachability.locationSelectPopover = null;
        Hafas.ps.pub('/favorites/trackDialogAction', ['dialog-cancelled']);
      }.bind(this),
      callback: function (html, err) {

      }
    });
  },
  hideLocationSelectionPopover: function(){
    var _me = this;
    if(_me.Controller.Reachability.locationSelectPopover) {
      var anchor = _me.Controller.Reachability.locationSelectPopover.getAnchorElement();
      if (anchor) {
        anchor.removeClassName('lyr_selectedFav');
      }
      _me.Controller.Reachability.locationSelectPopover.close();
      _me.Controller.Reachability.locationSelectPopover = null;
      Hafas.ps.pub('/favorites/trackDialogAction', ['dialog-cancelled']);
    }
  },
  updateLocationDisplay: function (loc) {
    var inputField = Hafas('#ReachabilityLocation', false);
    if (!inputField) {
      return;
    }

    if (loc != null) {
      inputField.value = Hafas.Util.getLocationAttribute(loc, "name");
    } else {
      inputField.value = '';
    }
  },
  changeDisplayMode: function (data) {
    // Vorübergehend so realisiert, bis Options Module direkte Übergabe der ausgewählten Werte unterstützt
    var selectBox = data.source;
    var selectedValue = data.source.options[data.source.selectedIndex].value;
    if (selectedValue == 1) {
      this.Controller.Reachability.instance.setColorMode('Colored');
    } else {
      this.Controller.Reachability.instance.setColorMode('BlackWhite');
    }
  },
  selectProduct: function (cls, boolval) {
    this.Controller.Reachability.instance.setProductClass(parseInt(cls, 10), boolval);
  },
  toggleErrorHint: function (type) {
    // When accessing Reachability from the map in small layout, form may have never been rendered. Check and render if necessary.
    if (Hafas('#HFS_WebApp').classList.contains('layout-small') && !this.Controller.Reachability.currentForm) {
      Hafas.ps.pub('/app/switchContext', [{
        context: 'Reachability',
        method: 'index'
      }]);
    }
    var validator = Hafas.Core.newType("hafasValidation", {form: this.Controller.Reachability.currentForm});
    var errorDomElem = Hafas('#ReachabilityLocation', false);
    if (errorDomElem) {
      switch (type) {
        case 'show':
          validator.showError(errorDomElem, 'noResults');
          if (Hafas('#HFS_WebApp').classList.contains('layout-small')) {
            Hafas.ps.pub('/GUI/map/hide', []);
          }
          break;
        case 'hide':
          validator.resetFields();
          break;
      }
      Hafas.ps.pub('/app/events/resize');
    }
  },
  /**
  * Clear map content that was created by the reachability search
  *
  * @method clearMap
  */
  clearMap: function(){
      Hafas.bind(this.Controller.Reachability.removeStationMarker, this)();
  },
  cleanup: function () {
    var me = this;
    Hafas.bind(me.Controller.Reachability.clearMap, me)();
    Hafas.bind(me.Controller.Reachability.hideResult, me)();
    Hafas.ps.pub('/GUI/form/hide', [{}]);
    Hafas.ps.pub("/map/closeAllToolboxItems", [])
  },
  closeView: function (histData) {
    var me = this;
    //Hafas.bind(me.Controller.Reachability.cleanup, me)();
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        break;
      case "options":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: false, view: 'options'}]);
        break;
      case "optionsDetails":
        histData.data.open = false;
        Hafas.ps.pub('/options/gui/toggle/group', [{
          groupId: 'HFS_ReachProductOptions',
          target: 'HFS_ReachProductOptions_Panel',
          view: 'optionsDetails',
          open: false
        }]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
      case "editSmartLocations":
        Hafas.ps.pub('/favorites/smartLocations/closeView');
        break;
    }
  },

  restoreView: function (histData) {
    var me = this;
    var view = histData.view;
    switch (view) {
      case "map":
      case "index":
        Hafas.bind(me.Controller.Reachability.index, me)();
        break;
      case "options":
        Hafas.bind(me.Controller.Reachability.index, me)();
        Hafas.ps.pub('/GUI/form/show', [{appcontext: 'Reachability'}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: true, view: 'options'}]);
        break;
      case "optionsDetails":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{open: true}]);
        histData.data.open = true;
        Hafas.ps.pub('/GUI/options/details/toggle', [histData.data]);
        break;
    }
  },

  /**
   * clears all input data (including options)
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt
    Hafas.Modules.History.removeCurrentStep("index");

    Hafas.ps.pub('/options/reset');

    var me = this;
    Hafas.bind(me.Controller.Reachability.removeStationMarker, me)();
    Hafas.bind(me.Controller.Reachability.hideResult, me)();
    me.Controller.Reachability.instance.setLocation(null); // Default aus dem Reachability-Modul
    me.Controller.Reachability.instance.setTravelTime(20); // Default aus dem Reachability-Modul
    me.Controller.Reachability.instance.setPeriod(30); // Default ist laut Modul 120, allerdings wird bereits dort immer 30 mit (this.period || 120) gesetzt
    me.Controller.Reachability.dateTimePicker.setTimeNowOn();
    me.Controller.Reachability.inpStation.resetLocation();
    Hafas.ps.pub("/map/closeAllToolboxItems", []);

    Hafas.ps.pub('/app/switchContext', [{context: 'Reachability', method: 'index'}]);

    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  }
};
